import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { UIModule } from "@flowtribe/ui";
import { SharedRoutingModule } from "./shared-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { MarkdownModule } from "ngx-markdown";
import { AvatarComponent } from "./components/avatar/avatar.component";
import { CustomFieldSearchPipe } from "./pipes/custom-field-search.pipe";
import { PhoneNumberInputComponent } from "../components/phone-number-input/phone-number-input.component";
import { IdCardStatusBadgeComponent } from "./components/idcard-status-badge/idcard-status-badge.component";
import { TypeableDateDirective } from "./directives/typeable-date.directive";
import { UiModalPortalDirective } from "./directives/ui-modal-portal.directive";
import { OverflowTooltipDirective } from "./directives/overflow-tooltip.directive";
import { DropdownMenuClassDirective } from "./directives/dropdown-menu-class.directive";
import { StickySentinelDirective } from "./directives/sticky-sentinel.directive";
import { FileDocumentComponent } from "./components/file-document/file-document.component";
import { FileRenameModalComponent } from "./components/file-rename-modal/file-rename-modal.component";
import { FileDeleteConfirmModalComponent } from "./components/file-delete-confirm-modal/file-delete-confirm-modal.component";
import { FilePreviewFallbackModalComponent } from "./components/file-preview-fallback-modal/file-preview-fallback-modal.component";
import { AccordionComponent } from "./components/accordion/accordion.component";
import { AccordionPanelComponent } from "./components/accordion/accordion-panel/accordion-panel.component";
import { StepStartConditionRowComponent } from "./components/step-start-condition-row/step-start-condition-row.component";
import { ProgressBarComponent } from "./components/progress-bar/progress-bar.component";
import { OverviewFilterBarComponent } from "./components/overview-filter-bar/overview-filter-bar.component";
@NgModule({
  declarations: [
    AvatarComponent,
    PhoneNumberInputComponent,
    IdCardStatusBadgeComponent,
    AccordionComponent,
    AccordionPanelComponent,
    FileDocumentComponent,
    FileRenameModalComponent,
    FileDeleteConfirmModalComponent,
    FilePreviewFallbackModalComponent,
    UiModalPortalDirective,
    OverflowTooltipDirective,
    DropdownMenuClassDirective,
    StickySentinelDirective,
    StepStartConditionRowComponent,
    ProgressBarComponent,
    OverviewFilterBarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedRoutingModule,
    UIModule,
    CustomFieldSearchPipe,
    TranslateModule,
    TypeableDateDirective,
    MarkdownModule
  ],
  exports: [
    TranslateModule,
    UIModule,
    AvatarComponent,
    StepStartConditionRowComponent,
    CustomFieldSearchPipe,
    PhoneNumberInputComponent,
    IdCardStatusBadgeComponent,
    TypeableDateDirective,
    AccordionComponent,
    AccordionPanelComponent,
    FileDocumentComponent,
    FileRenameModalComponent,
    FileDeleteConfirmModalComponent,
    FilePreviewFallbackModalComponent,
    UiModalPortalDirective,
    OverflowTooltipDirective,
    DropdownMenuClassDirective,
    StickySentinelDirective,
    ProgressBarComponent,
    OverviewFilterBarComponent
  ]
})
export class SharedModule {}
